import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as requests from '../api/requests';
import { addErrorNotification } from './notificationsSlice';

const initialState = {
  certificatesInfo: [],
  imgSrc: '',
};

// ---------------------- ASYNC THUNKS ----------------------

export const getCertificatesInfo = createAsyncThunk(
  'certificateReceiverHome/getCertificatesInfo',
  async (_, thunkAPI) => {
    const res = await requests.getCertificateReceiverHomeInfo();
    const body = await res.json();

    if (!res.ok) {
      thunkAPI.dispatch(
        addErrorNotification(
          body.errmsg || 'Something Went Wrong When Fetching The Certificate Info!'
        )
      );
    }

    return { ok: res.ok, body };
  }
);

export const verifyCert = createAsyncThunk(
  'certificateReceiverHome/verifyCert',
  async ({ certificateId }, thunkAPI) => {
    const res = await requests.verifyCert(certificateId);
    const body = await res.json();

    if (!res.ok) {
      thunkAPI.dispatch(
        addErrorNotification(
          body.errmsg || 'Something Went Wrong When Fetching The Certificate!'
        )
      );
    }

    return { ok: res.ok, body };
  }
);

// ---------------------- SLICE ----------------------

export const certificateReceiverHomeSlice = createSlice({
  name: 'certificateReceiverHome',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getCertificatesInfo.fulfilled, (state, { payload }) => {
        if (payload.ok) {
          state.certificatesInfo = [...payload.body.certificates];
        }
      })
      .addCase(verifyCert.fulfilled, (state, { payload }) => {
        if (payload.ok) {
          const certificateBase64 = payload.body.certificate;
          const blob = new Blob([Buffer.from(certificateBase64, 'base64')]);
          state.imgSrc = URL.createObjectURL(blob);
        }
      });
  },
});

export default certificateReceiverHomeSlice.reducer;
